import React, { Suspense, useEffect, useState } from "react";
import mainImage from "../assets/images/main_image.png";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, EffectCoverflow, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/effect-coverflow';
import 'swiper/css/autoplay';
import 'swiper/css/navigation';
import { FileDownload, Instagram, LinkedIn, TextSnippet } from "@mui/icons-material";
import { Link } from "react-router-dom";
import { InstaURL, LInkdinURL } from "../Config";
const LazyMainVideo = React.lazy(() => import("./MainVideo"));



const HeroSection = () => {

     const [blobShape, setBlobShape] = useState(generateBlobShape());

     useEffect(() => {
          const interval = setInterval(() => {
               setBlobShape(generateBlobShape());
          }, 1000);

          return () => clearInterval(interval);
     });

     function generateBlobShape() {
          const v1 = random(20, 80);
          const v2 = 100 - v1;
          const v3 = random(20, 80);
          const v4 = 100 - v3;

          return `${v1}% ${v2}% ${v3}% ${v4}% / ${v3}% ${v1}% ${v2}% ${v4}%`;
     }

     function random(min, max) {
          return Math.floor(Math.random() * (max - min + 1)) + min;
     }

     return (
          <section className="hero">
               <div className="content-center">
                    <div className="__banner-sec">
                         <div className="row">
                              <div className="col-lg-5">
                                   <div className="__banner-content">
                                        <h1>Craft with purpose Code with clarity.</h1>
                                        <p>Hi - I’m Parwinder Singh, a React Native developer building reliable, performant cross-platform mobile apps. I deliver production-ready apps with clean architecture, secure storage, smooth animations, and real-world integrations - maps, background location, camera, crypto wallets, and more.</p>
                                        <div className="__banner-btn">
                                             <a href="/resume.pdf" target="_blank" className="btn"> <TextSnippet/> Resume </a>
                                             <a href="/resume.pdf" download={true} className="btn-icon" > <FileDownload /> </a>
                                             <Link target="_blank" to={InstaURL} className="btn-icon" > <Instagram /> </Link>
                                             <Link target="_blank" to={LInkdinURL} className="btn-icon"> <LinkedIn /> </Link>
                                        </div>
                                        <h5>Web Partner :   <Link to="https://thedc-xi.vercel.app/" target="_blank"> Sunil Sharma </Link></h5>
                                   </div>
                              </div>

                              <div className="col-lg-7">
                                   <div className="__swiper">
                                        <Swiper
                                             loop={true}
                                             centeredSlides={false}
                                             autoplay={{
                                                  delay: 3000,
                                                  pauseOnMouseEnter: true,
                                             }}
                                             breakpoints={{
                                                  576: {
                                                       slidesPerView: 1,
                                                       spaceBetween: 1,
                                                  },
                                             }}
                                             pagination={{
                                                  clickable: true,
                                             }}
                                             speed={1000}
                                             effect={'coverflow'}
                                             grabCursor={true}
                                             slidesPerView={'auto'}
                                             coverflowEffect={{
                                                  rotate: 50,
                                                  stretch: 0,
                                                  depth: 0,
                                                  modifier: 3,
                                                  slideShadows: true,
                                             }}
                                             modules={[Pagination, EffectCoverflow, Autoplay]}
                                             className="mySwiper">

                                             <SwiperSlide>
                                                  <div className="__banner-vedio">
                                                       <Suspense fallback={<div>Loading...</div>}>
                                                            <LazyMainVideo />
                                                       </Suspense>
                                                  </div>
                                             </SwiperSlide>
                                             <SwiperSlide>
                                                  <div className="__swiper-auther" style={{ "--bob-radius": blobShape }}>
                                                       <div className="__img">
                                                            <img src={mainImage} alt="Deadpool" className="character" />
                                                       </div>
                                                  </div>
                                             </SwiperSlide>
                                        </Swiper>

                                   </div>

                              </div>
                         </div>
                    </div>


               </div>
          </section>
     );
};

export default HeroSection;

